import React from "react";
import SectionText from "../SectionText/SectionText";
import * as styles from './sectionFeature.module.scss';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import { toCamelCase, toAttachedString } from "../../utils/helpers/helpers";
import { RichText } from "../RichText/RichText";
import TextBlock from "../TextBlock/TextBlock";
import { Gallery } from "./gallery";
import { useUrl, useLocalPath } from "../../hooks";
import Img from "gatsby-image"
import { useLocale } from "../../hooks";
import { phase2Locales } from "../../utils/mapping";

const SectionBackground = ({ background }) => {
    return (
        <GatsbyImage
            className={styles.bgImage}
            image={background.gatsbyImageData}
            alt={background.title}
        />
        // <Img fluid={background.fluid} alt={background.title} className={styles.bgImage} />
    )
}

const SectionHeading = ({ headingLevel, children, headingOne }) => {
    return (
        headingLevel == 1 ?
            <h1 className={`heading heading-1`}>{children}</h1>
            :
            <h2 className={`heading ${headingOne === 'true' ? 'heading-1' : 'heading-2'}`}>{children}</h2>
    )
}

export const SectionCTA = ({ button, lowercase = false, setter }) => {
    //console.log("button",button.external);
    const baseUrl = useUrl()
    const closePopUp = () =>{
        if(setter){
            setter(true)
        }
    }
    return (
        <div  onClick = {closePopUp}>
            {!!button.externalLink ? (
                <a href={button.externalLink} className={`btn btn--primary ${(button.lowercase || lowercase) && styles.lowercase}`} target="_blank" rel="noopener noreferrer" aria-label="Opens in a new window">
                    {button.title}
                </a>
            ) : (
                <Link to={useLocalPath(button.link)} className={`btn btn--primary ${button.invertColors && styles.buttonInvert} ${(button.lowercase || lowercase) && styles.lowercase}`} >
                    {button.title} 
                </Link>
            )}
        </div>
    )
}

const SectionImages = ({ images, appearance }) => {
    const locale = useLocale()
    return (
        appearance === "with-gallery" && images.length === 3 ?
            <Gallery data={
                {
                    images: images
                }
            } />

            :
            <div className={`${images.length > 1 ? styles.imagesMargin : (locale === "ar-AE" || locale === "ur-PK") ? styles.imagesRtl : styles.images} `}>
                {images.map((image, idx) => (
                    <div className={styles.imageWrapper} key={idx}>
                        <GatsbyImage
                            key={idx}
                            className={styles.image}
                            image={image.gatsbyImageData}
                            alt={image.title}
                            objectFit={phase2Locales[locale] ? 'contain' : 'contain'}
                        />
                        {/* <Img fluid={image.fluid} alt={image.title} className={styles.image} /> */}
                    </div>
                ))}
            </div>
    )
}

export const SectionFeature = ({
    data,
    scrollToAnchor,
    imageTop,
    noMargin,
    home
}) => {
    //console.log(data);

    const {
        title,
        headingLevel,
        wideDescription,
        alignment,
        description,
        images,
        button,
        appearance,
        backgroundImage,
        isColumnLayout,
        variant,
    } = data;

    const css = appearance ? toCamelCase(appearance) : '';
    // const isColumnLayout = variant === "columns";
    const locale = useLocale()
    return (
        <div className={`${noMargin ? styles.sectionWithNoMargine : styles.section} ${styles[css] || ''} ${styles[variant] || ''}`}>
            {backgroundImage && <SectionBackground background={backgroundImage} />}
            <div className={`container container-lg ${(locale === "ar-AE" || locale === "ur-PK") ? styles.wrapperRtl : styles.wrapper}`}>
                <div className={styles.content}>
                    {imageTop && !!images && !isColumnLayout && !!images.length && (
                        <SectionImages images={images} appearance={appearance} />
                    )}

                    <SectionHeading headingLevel={headingLevel} headingOne={home ? 'true' : 'false'}>{title}</SectionHeading>

                    {description && (
                        <div className="description-text">
                            <TextBlock
                                data={description}
                                wideDescription={wideDescription}
                                alignment={alignment}
                            />
                        </div>
                    )}

                    {!imageTop && !!images && !isColumnLayout && !!images.length && (
                        <SectionImages images={images} appearance={appearance} />
                    )}

                    {button && <SectionCTA button={button} />}
                </div>

                {!!images && isColumnLayout && !!images.length && (
                    <SectionImages images={images} appearance={appearance} />
                )}
            </div>
        </div>
    );
}

export default SectionFeature;